<ion-header>
  <ion-toolbar class="ion-text-center">
    <ion-buttons slot="start">
      <ion-button (click)="dismissModal()">
        <ion-icon name="arrow-back"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>SimPayX </ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-grid>
    <ion-row>
      <ion-col size="12">
        <ion-text>
          <h2 class="ion-no-margin">Terms and Conditions</h2>
        </ion-text>
      </ion-col>
      <ion-col size="12">
        <ion-text>
          <h6 class="spx-font-12 ion-no-margin text-color-black">
            Welcome! We, at SimPayX are very happy to serve you. Before you use
            our platform, please read the Terms of Use carefully. These Terms of
            Use (“Terms”, “Agreement”) constitutes a legal agreement between you
            and SimPayX, its related platforms and subdomains (collectively
            “SimPayX”, “We”, “Our” or “Us”)
          </h6>
        </ion-text>
      </ion-col>

      <ion-col size="12">
        <ion-text>
          <h4 class="spx-font-12 ion-no-margin text-color-black">
            <ion-icon class="zoom" name="ellipse"></ion-icon>
            Acceptance to this Agreement:
          </h4>
          <h6>
            SimPayX provides an online platform using different web technologies
            to connect you with restaurants and or businesses. SimPayX software
            enables you to place order either in the restaurant premise and/or
            outside the restaurant premise and pay for our order to the
            restaurant and/or business. The software notifies you about the
            progress of your order (acceptance of order, rejection of order and
            order ready for pickup), in case of orders placed online from
            outside the restaurant premise location. SimPayX also enables you to
            reserve services provided by restaurant and/or businesses in advance
            using our software which connects directly with the restaurant
            and/or business to provide and notify them with the reservation
            details. SimPayX is not a restaurant, delivery service, or food
            preparation business. By accessing any of our services or software,
            you, your heirs, assigns and successors (collectively “you”, “your”)
            hereby represent and warrant that: (a) you have read, understand,
            and agree to be bound by this Agreement; (b) you are of legal age in
            the jurisdiction in which you reside to form a binding contract with
            SimPayX; and (c) you have the authority to enter into the Agreement
            personally and, if applicable, on behalf of any organization on
            whose behalf you have created an account and to bind such
            organization to the Agreement.
          </h6>
        </ion-text>
      </ion-col>

      <ion-col size="12">
        <ion-text>
          <h4 class="spx-font-12 ion-no-margin text-color-black">
            <ion-icon class="zoom" name="ellipse"></ion-icon>
            Changes to Terms:
          </h4>
          <h6>
            SimPayX may vary or amend or change or update these Terms, from time
            to time entirely at its own discretion. You shall be responsible for
            checking these Terms from time to time and ensure continued
            compliance with these Terms. Your use of SimPayX serivces and/or
            platform after any such amendment or change in the Terms shall be
            deemed as your express acceptance to such amended/changed terms and
            you also agree to be bound by such changed/amended Terms.
          </h6>
        </ion-text>
      </ion-col>

      <ion-col size="12">
        <ion-text>
          <h4 class="spx-font-12 ion-no-margin text-color-black">
            <ion-icon class="zoom" name="ellipse"></ion-icon>
            User Content:
          </h4>
          <h6>
            SimPayX may provide you with interactive opportunities through the
            Services, including, by way of example, the ability to post User
            ratings and reviews (collectively, “User Content”). You represent
            and warrant that you are the owner of, or otherwise have the right
            to provide, all User Content that you submit, post and/or otherwise
            transmit through the Services. You further represent and warrant
            that any User Content that you submit, post and/or otherwise
            transmit through the Services (i) does not violate any third-party
            right, including any copyright, trademark, patent, trade secret,
            privacy right, right of publicity, or any other intellectual
            property or proprietary right; (ii) does not contain material that
            is false, intentionally misleading, or defamatory; (iii) does not
            contain any material that is unlawful; (iv) does not violate any law
            or regulation; and (v) does not violate this Agreement. You hereby
            grant SimPayX a perpetual, irrevocable, transferable, fully paid,
            royalty-free, non-exclusive, worldwide, fully sublicensable right
            and license to use, copy, display, publish, modify, remove, publicly
            perform, translate, create derivative works, distribute and/or
            otherwise use the User Content in connection with SimPayX’s business
            and in all forms now known or hereafter invented (“Uses”), without
            notification to and/or approval by you. You further grant SimPayX a
            license to use your username, first name and last initial, and/or
            other User profile information, including without limitation, your
            ratings history, to attribute User Content to you in connection with
            such Uses, without notification or approval by you. You agree that
            this license includes the right for other Users to access and use
            your User Content in conjunction with participation in the Services
            and as permitted through the functionality of the Services. In the
            interest of clarity, the license granted to SimPayX herein shall
            survive termination of the Services or your account. SimPayX
            reserves the right in its sole discretion to remove or disable
            access to any User Content from the Services, suspend or terminate
            your account at any time, or pursue any other remedy or relief
            available under equity or law if you post any User Content that
            violates this Agreement or any community or content guidelines we
            may publish or that we consider to be objectionable for any reason.
            You agree that SimPayX may monitor and/or delete your User Content
            (but does not assume the obligation) for any reason in SimPayX’s
            sole discretion. SimPayX may also access, read, preserve, and
            disclose any information as SimPayX reasonably believes is necessary
            to (a) satisfy any applicable law, regulation, legal process, or
            governmental request, (b) enforce this Agreement, including
            investigation of potential violations hereof, (c) detect, prevent,
            or otherwise address fraud, security, or technical issues, (d)
            respond to User support requests, or (e) protect the rights,
            property or safety of SimPayX, its Users and the public.
          </h6>
        </ion-text>
      </ion-col>

      <ion-col size="12">
        <ion-text>
          <h4 class="spx-font-12 ion-no-margin text-color-black">
            <ion-icon class="zoom" name="ellipse"></ion-icon>
            Payments:
          </h4>
          <h6>
            You understand that prices of the menu items may differ from other
            third-party platforms and that SimPayX does not hold responsibility
            for the prices set by the Merchant for their restaurant and/or
            business. SimPayX uses third party vendor to complete transactions
            whenever payment is required and your payment details will be shared
            with them in order to complete the payment
          </h6>
        </ion-text>
      </ion-col>

      <ion-col size="12">
        <ion-text>
          <h4 class="spx-font-12 ion-no-margin text-color-black">
            <ion-icon class="zoom" name="ellipse"></ion-icon>
            Communication with SimPayX:
          </h4>
          <h6>
            By using services provided by SimPayX you electronically agree to
            accept and receive communications from SimPayX via different means,
            for example and not limited to, SMS text, email. That we share your
            data with our vendors for verification as well as sending
            notifications and communications regarding your transactions with
            SimPayX.
          </h6>
        </ion-text>
      </ion-col>

      <ion-col size="12">
        <ion-text>
          <h4 class="spx-font-12 ion-no-margin text-color-black">
            <ion-icon class="zoom" name="ellipse"></ion-icon>
            Voucher:
          </h4>
          <h6>
            Vouchers provided on the SimPayX application are subject to
            availability. These vouchers are non-refundable and cannot be
            exchanged for cash in part or full and can be used for a single
            transaction only. SimPayX can amend/modify the terms and conditions
            of these vouchers at its discretion
          </h6>
        </ion-text>
      </ion-col>

      <ion-col size="12">
        <ion-text>
          <h4 class="spx-font-12 ion-no-margin text-color-black">
            <ion-icon class="zoom" name="ellipse"></ion-icon>
            Reservation:
          </h4>
          <h6>
            SimPayX provides platform which enables you to make reservation with
            restaurants and/or businesses. SimPayX does not hold liability in
            the case when services in such restaurants or business is altered,
            unavailable or changed in any manner. Any modification and/or
            cancellation done by merchant, restaurant and/or business during the
            time of service is at their sole discretion.
          </h6>
        </ion-text>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>

<ion-footer>
  <ion-row>
    <ion-col size="12">
      <ion-button expand="block" (click)="dismissModal()">OK</ion-button>
    </ion-col>
  </ion-row>
</ion-footer>
